const getDefaultState = () => {
  return {
    connectRequests: false,
    messenger: false,
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  ACTIVATE_INDICATOR(state, indicator) {
    state[indicator] = true;
  },

  TURN_OFF_INDICATOR(state, indicator) {
    state[indicator] = false;
  },

};

// Asynchronous
const actions = {
  resetState({commit}) {
    commit("RESET_STATE");
  },
  activateIndicator({commit}, indicator) {
    commit("ACTIVATE_INDICATOR", indicator);
  },

  turnOffIndicator({commit}, indicator) {
    commit("TURN_OFF_INDICATOR", indicator);
  },
};

const indicators = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default indicators;
  